import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

export default React.memo(function LinkFulfilled({ className = '', children, external, ...props }) {

  const Element = useMemo(() => external ? ({ children, to, ...props }) => <a rel={'noopener noreferrer'} href={to} {...props}>{children}</a> : Link, [external]);

  return (
    <Element {...props}
             className={`rounded-2xl flex items-center justify-center py-5 bg-gradient select-none ${className}`}>
      {children}
    </Element>
  );
})
